module.exports = __webpack_public_path__ + "static/cookie-67683b2cb1baf309f16b721e2656d1e0.png";